import { Component } from '@angular/core';

@Component({
	selector: 'ae-no-permission',
	templateUrl: './no-permission.component.html',
	styleUrls: ['./no-permission.component.scss'],
})
export class NoPermissionComponent {}
